import React from 'react';
import ReactDOM from 'react-dom/client';
import './Generales/index.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

// Páginas públicas
import Principal from './Paginas/Principal';
import SobreNosotros from './Paginas/SobreNosotros';

// Admin - Autenticación
import { AuthProvider } from './admin/hooks/useAuth';
import ProtectedRoute from './admin/components/auth/ProtectedRoute';
import Login from './admin/pages/Login';
import Signup from './admin/pages/Signup';
import PasswordReset from './admin/pages/PasswordReset';

// Admin - Páginas
import ProductosPage from './admin/pages/ProductosPage';
import CategoriasPage from './admin/pages/CategoriasPage';

// Admin - Estilos
import './admin/styles/admin.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Rutas Públicas */}
            <Route path="/" element={<Principal />} />
            <Route path="/sobre-nosotros" element={<SobreNosotros />} />

            {/* Rutas Admin - Autenticación */}
            <Route path="/admin/login" element={<Login />} />
            <Route path="/admin/signup" element={<Signup />} />
            <Route path="/admin/password-reset" element={<PasswordReset />} />

            {/* Rutas Admin - Protegidas */}
            <Route
              path="/admin"
              element={<Navigate to="/admin/productos" replace />}
            />
            <Route
              path="/admin/productos"
              element={
                <ProtectedRoute>
                  <ProductosPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/categorias"
              element={
                <ProtectedRoute>
                  <CategoriasPage />
                </ProtectedRoute>
              }
            />
            {/* Ruta 404 - Redirigir a home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);